/*eslint-disable*/
import { Avatar } from 'antd';
import FeatherIcon from 'feather-icons-react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { API } from '../../../config/api';
import { logOut } from '../../../redux/authentication/actionCreator';
import Heading from '../../heading/heading';
import { Popover } from '../../popup/popup';
import { InfoWraper, UserDropDwon } from './auth-info-style';
import NotificationBox from './notification';

function AuthInfo() {
  const dispatch = useDispatch();
  const { auth, users } = useSelector((state) => {
    return {
      auth: state.auth.login.user,
      users: state.users.users,
    };
  });
  const [state, setState] = useState({
    flag: 'english',
  });
  const { flag } = state;

  const SignOut = (e) => {
    e.preventDefault();
    dispatch(logOut());
  };

  const userData = (Array.isArray(users) ? users : []).find((user) => user._id === auth?.id) || auth;
  const displayName = String(userData?.name || auth?.name || 'User').replace(/_/g, ' ').replace(/\b[a-z]/g, letter => letter.toUpperCase());
  const image = typeof userData?.image === 'string' ? userData.image.trim() : '';
  const avatarSrc = image && !['undefined', 'null'].includes(image)
    ? (/^https?:\/\//i.test(image) ? image : `${API.images}/${image}`)
    : undefined;

  const userContent = (
    <UserDropDwon>
      <div className="user-dropdwon">
        <figure className="user-dropdwon__info">
          {/* <img src={require('../../../static/img/avatar/chat-auth.png')} alt="" /> */}
          <Avatar key={avatarSrc || 'default'} src={avatarSrc} size={60} icon={<FeatherIcon icon="user" size={26} style={{ display: 'block' }} />} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, flexShrink: 0, background: '#F0F0FF', color: '#5F63F2' }} />
          <figcaption>
            <Heading as="h5" className="profile-display-name">{displayName}</Heading>
            <p>{userData?.role || userData?.roles || auth?.role}</p>
          </figcaption>
        </figure>
        <ul className="user-dropdwon__links">
          <li>
            <Link to="/admin/profile">
              <FeatherIcon icon="user" /> Profile
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="settings" /> Settings
            </Link>
          </li>
          {/* <li>
            <Link to="#">
              <FeatherIcon icon="dollar-sign" /> Billing
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="users" /> Activity
            </Link>
          </li>
          <li>
            <Link to="#">
              <FeatherIcon icon="bell" /> Help
            </Link>
          </li> */}
        </ul>
        <Link className="user-dropdwon__bottomAction" onClick={SignOut} to="#">
          <FeatherIcon icon="log-out" /> Sign Out
        </Link>
      </div>
    </UserDropDwon>
  );

  const onFlagChangeHandle = (value) => {
    setState({
      ...state,
      flag: value,
    });
  };

  // const country = (
  //   <NavAuth>
  //     <Link onClick={() => onFlagChangeHandle('english')} to="#">
  //       <img src={require('../../../static/img/flag/english.png')} alt="" />
  //       <span>English</span>
  //     </Link>
  //     <Link onClick={() => onFlagChangeHandle('germany')} to="#">
  //       <img src={require('../../../static/img/flag/germany.png')} alt="" />
  //       <span>Germany</span>
  //     </Link>
  //     <Link onClick={() => onFlagChangeHandle('spain')} to="#">
  //       <img src={require('../../../static/img/flag/spain.png')} alt="" />
  //       <span>Spain</span>
  //     </Link>
  //     <Link onClick={() => onFlagChangeHandle('turky')} to="#">
  //       <img src={require('../../../static/img/flag/turky.png')} alt="" />
  //       <span>Turky</span>
  //     </Link>
  //   </NavAuth>
  // );

  return (
    <InfoWraper>
      <NotificationBox />
      {/* <Message />

      <Settings />
      <Support /> */}
      {/* <div className="nav-author">
        <Dropdown placement="bottomRight" content={country} trigger="click">
          <Link to="#" className="head-example">
            <img src={require(`../../../static/img/flag/${flag}.png`)} alt="" />
          </Link>
        </Dropdown>
      </div> */}

      <div className="nav-author">
        <Popover placement="bottomRight" content={userContent} action="click">
          <Link to="#" className="head-example">
            <Avatar key={avatarSrc || 'default'} src={avatarSrc} icon={<FeatherIcon icon="user" size={18} style={{ display: 'block' }} />} style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1, background: '#F0F0FF', color: '#5F63F2' }} />
          </Link>
        </Popover>
      </div>
    </InfoWraper>
  );
}

export default AuthInfo;
